import {Component, EventEmitter, Output, OnInit, ViewChild, Input} from '@angular/core';

import {AlgoliaQueryBuilder, AlgoliaQueryFacetFilterItem, IAlgoliaSearchResults} from '@nxt/model-core';

import {getUsersByRoleFilterSets, IAlgoliaFilterSet} from '../../shared/search/algolia-search.component';

import {AlgoliaSearchComponent} from '../../shared/search/algolia-search.component';
import {take} from 'rxjs/operators';
import {
    endOfDay,
    endOfMonth,
    endOfYear, format,
    startOfDay,
    startOfMonth,
    startOfYear,
    subMonths,
    subYears
} from 'date-fns';
import {AccountService} from '../_services/account.service';
import {ClientService} from '../../shared/_services/client.service';
import {PageService} from '../../shared/_services/page.service';
import {DateRangeDialog} from '../../shared/input/date-range.dialog';
import {UserService} from '../_services/user.service';
import {AsyncPipe} from '@angular/common';

@Component({
    standalone: true,
    imports: [
        AsyncPipe,
        AlgoliaSearchComponent
    ],
    selector: 'nxt-quote-search',
    template: `
        <algolia-search-component
                #searchComponent
                index="quotes"
                placeholder="Search Quotes"
                [saveSearch]="saveSearch"
                subtype="quotes"
                [hitsPerPage]="pagingSize"
                [savedSearchUser]="uSvc.user$|async"
                (onResults)="onResults.emit($event)"
                [filterSet]="filterSets"
                [preSearchLogic]="preSearchLogic"
                (onClear)="onClear.emit($event)"
        ></algolia-search-component>
    `
})
export class NewNxtQuoteSearchComponent implements OnInit {
    @Output() onResults: EventEmitter<[IAlgoliaSearchResults, boolean]> = new EventEmitter<[IAlgoliaSearchResults, boolean]>();
    @Output() onClear: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('searchComponent', {static: true}) searchComponent: AlgoliaSearchComponent;
    @Input() saveSearch: boolean = true;
    @Input() pagingSize: number;
    type: string = 'quotes';
    filterSets: IAlgoliaFilterSet[];

    constructor(
        public uSvc: UserService,
        private aSvc: AccountService,
        private cSvc: ClientService,
        private pSvc: PageService
    ) {
    }

    ngOnInit() {
        this.loadFilters();
    }

    async loadFilters() {
        let now: Date = new Date();
        let start: Date = new Date();
        let end: Date = new Date();

        this.filterSets = [];
        let dateSet:IAlgoliaFilterSet[] = [
            {
                name: 'Date Filters',
                buttons: [
                    {
                        label: 'Custom Date Range',
                        class: 'btn-dark',
                        click: () => {
                            this.pSvc.modal$.next({
                                label: 'Custom Date Range',
                                component: DateRangeDialog,
                                styles: {
                                    width: '600px'
                                },
                                onLoaded: (comp: DateRangeDialog) => {
                                    comp.start = start;
                                    comp.end = end;
                                    comp.onClose
                                        .pipe(take(1)).subscribe(
                                        (result: {start:Date, end:Date}) => {
                                            
                                            if (result) {
                                                start = result.start;
                                                end = result.end;
                                                this.searchComponent.builder.remove('filterItems', {id:'CUSTOM'});
                                                this.searchComponent.toggleFilter({
                                                    id: 'CUSTOM',
                                                    name: `${format(start,'MMM d, yyyy')} > ${format(end,'MMM d, yyyy')}`,
                                                    color: '#505cac',
                                                    contrast: '#ffffff',
                                                    key: 'Date',
                                                    type: 'numeric',
                                                    key_unique: true,
                                                    more: `date>${start.valueOf()}`,
                                                    value: `date<${end.valueOf()}`
                                                });
                                            }
                                        }
                                    );
                                    comp.ngOnChanges();
                                }
                            });
                        }
                    }
                ],
                items: [
                    {
                        id: 'MONTH',
                        name: 'Current Month',
                        color: '#505cac',
                        contrast: '#ffffff',
                        key: 'Date',
                        type: 'numeric',
                        key_unique: true,
                        more: `date>${startOfMonth(startOfDay(now)).valueOf()}`,
                        value: `date<${endOfMonth(endOfDay(now)).valueOf()}`
                    },
                    {
                        id: 'LAST_MONTH',
                        name: 'Previous Month',
                        color: '#505cac',
                        contrast: '#ffffff',
                        key: 'Date',
                        type: 'numeric',
                        key_unique: true,
                        more: `date>${subMonths(startOfMonth(startOfDay(now)),1).valueOf()}`,
                        value: `date<${subMonths(endOfMonth(endOfDay(now)),1).valueOf()}`
                    },
                    {
                        id: 'YEAR',
                        name: 'Current Year',
                        color: '#7481d5',
                        contrast: '#ffffff',
                        key: 'Date',
                        type: 'numeric',
                        key_unique: true,
                        more: `date>${startOfYear(startOfDay(now)).valueOf()}`,
                        value: `date<${endOfYear(endOfDay(now)).valueOf()}`
                    },
                    {
                        id: 'YEAR',
                        name: 'Last Year',
                        color: '#7481d5',
                        contrast: '#ffffff',
                        key: 'Date',
                        type: 'numeric',
                        key_unique: true,
                        more: `date>${subYears(startOfYear(startOfDay(now)),1).valueOf()}`,
                        value: `date<${subYears(endOfYear(endOfDay(now)),1).valueOf()}`
                    }
                ]
            }
        ];
        let roleSet = await getUsersByRoleFilterSets(this.aSvc, this.cSvc);
        this.filterSets = dateSet.concat(roleSet);
    }


    preSearchLogic(builder: AlgoliaQueryBuilder): AlgoliaQueryBuilder {
        if (builder) {
            let item: AlgoliaQueryFacetFilterItem = new AlgoliaQueryFacetFilterItem({
                id: 'quote_id',
                name: '',
                key: 'quote_id',
                key_unique: true,
                value: `quote_id:${builder.query}`
            });
            builder.removeFilter(item);
            if (builder.query?.match(/Q-[0-9]{6}[a-zA-Z]{4}/i)) {
                builder.addFilter(item);
            }
        }
        return builder;
    }

}
